import React, { useCallback, useMemo } from "react";
import { useNavigate } from "react-router";
import { Box, View, useDevice } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Button, Text } from "@lookiero/sty-psp-ui";
import { useStaticInfo } from "../../../../hooks/useStaticInfo";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { Routes } from "../../../../routing/routes";
import { style as noOrdersStyle } from "./NoOrders.styles";

const NoOrders = () => {
  const { screen } = useDevice();
  const isLargeDesktop = screen.L || screen.M;

  const myOrderEmptyTitle = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.MY_ORDER_EMPTY_TITLE,
  });
  const myOrderEmptyBody = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.MY_ORDER_EMPTY_BODY,
  });
  const emptyStateCtaText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.EMPTY_STATE_CTA,
  });

  const { basePath } = useStaticInfo();
  const navigate = useNavigate();
  const handleOnPress = useCallback(() => navigate(`${basePath}/${Routes.HOME}`), [basePath, navigate]);

  const style = useMemo(() => noOrdersStyle(), []);

  return (
    <View style={[style.outerWrapper, isLargeDesktop ? style.largeOuterWrapper : undefined]}>
      <Box style={style.titleArea}>
        <Text level={3} style={style.title} testID="home-title" variant="heading">
          {myOrderEmptyTitle}
        </Text>
        <Text>{myOrderEmptyBody}</Text>
      </Box>

      <Button style={{ button: style.buttonCTA }} variant="primary" onPress={handleOnPress}>
        {emptyStateCtaText}
      </Button>
    </View>
  );
};

export { NoOrders };
